import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {EntityAccountManagerLinkContainerModel} from '../../../../../../models/aggregates/erp/entity';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})

export class EntityAccountManagerLinkService extends BaseApiPublicLoginTemplateService<EntityAccountManagerLinkContainerModel, EntityAccountManagerLinkContainerModel, EntityAccountManagerLinkContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  +  Core2Config.ERP_PREFIX + 'entity-acc-manager-link';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-acc-manager-link';
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-acc-manager-link/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.httpClient = http;
  }
}
